import HTMLReactParser from "html-react-parser";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import { closeTooltip } from "../../store/actions";
import { isMouseOverElement, isTouchScreen, setPositionToViewPort } from "../../lib/elementUtilities";

const mapDispatchToProps = dispatch => ({
  closeTooltip: () => dispatch(closeTooltip())
})

const connector = connect(null, mapDispatchToProps);

const StaticTooltip = (props) => {
  const divRef = useRef();

  const [style, setStyle] = useState({ display: "block", top: undefined });
  // const [overTrigger, setOverTrigger] = useState(true);
  // const [overTooltip, setOverTooltip] = useState(false);

  const handleClickOutside = (e) => {
    if (!divRef.current || divRef.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    props.closeTooltip();
  };

  const handleHoverOutTrigger = (e) => {
    if (isTouchScreen()) {
      return;
    }
    if (!divRef.current || isMouseOverElement(e.x, e.y, divRef.current)) {
      return;
    }

    props.closeTooltip();
  }

  const handleHoverOutTooltip = (e) => {
    if (isTouchScreen()) {
      return;
    }
    if (!props.elementRef.current || isMouseOverElement(e.x, e.y, props.elementRef.current)) {
      return;
    }

    props.closeTooltip();
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    if (props.elementRef.current) {
      props.elementRef.current.addEventListener("mouseleave", e => handleHoverOutTrigger(e));
      // props.elementRef.current.addEventListener("mouseover", handleHoverInTrigger);
    }
    if (divRef.current) {
      divRef.current.addEventListener("mouseleave", e => handleHoverOutTooltip(e));
      // divRef.current.addEventListener("mouseover", handleHoverInTooltip);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
      if (props.elementRef.current) {
        props.elementRef.current.removeEventListener("mouseleave", handleHoverOutTrigger);
        // props.elementRef.current.removeEventListener("mouseover", handleHoverInTrigger);
      }
      if (divRef.current) {
        divRef.current.removeEventListener("mouseleave", handleHoverOutTooltip);
        // divRef.current.removeEventListener("mouseover", handleHoverInTooltip);
      }
    };
  }, []);

  useEffect(() => {
    if (props.elementRef) {
      let position = {};
      position.left = props.elementRef.current.getBoundingClientRect().left
        - (divRef.current.getBoundingClientRect().width
          - props.elementRef.current.getBoundingClientRect().width) / 2 + window.scrollX;
      position.top = props.elementRef.current.getBoundingClientRect().bottom + window.scrollY;

      if (divRef.current) {
        position = setPositionToViewPort(divRef.current, position);
      }

      setStyle({
        ...style,
        ...position
      })
    }
  }, [props.elementRef]);

  return (
    <div
      className={`tooltip ${props.classes?.join(" ")}`}
      style={style}
      ref={divRef}
      onMouseLeave={props.closeControl && props.closeTooltip}
    >
      {props.title && <h3 className="title">{props.title}</h3>}
      {props.content && HTMLReactParser(props.content)}
    </div>
  )
};

export default connector(StaticTooltip);
